import { createContext } from 'react';
import { UpdateAirbnbAlterationRequestModalContextProps } from './UpdateAirbnbAlterationModal.types';

const AirbnbAlterationRequestModalContext =
  // @ts-expect-error TS2345 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
  createContext<UpdateAirbnbAlterationRequestModalContextProps>(undefined);

export default AirbnbAlterationRequestModalContext;
